@if (authenticated) {
  <div
    class="sticky-navbar"
    [class.d-block]="!isMobile"
    [class.mw-xs-xl-1280p]="!isMobile"
    [class.d-xl-block]="isMobile"
    [class.d-none]="isMobile"
    appFullScreenMode
    [appBorderBoxResizeObserver]="'navbarBorderBox'"
    >
    <app-navbar />
    <app-sub-navbar class="app-sub-navbar" />
  </div>
  @if (isThirdNavbarOpen) {
    <app-third-navbar [class.d-none]="isMobile" class="d-xl-block" />
  }
  @if (isMobile) {
    <app-mobile-navbar class="sticky-navbar d-block d-xl-none vw-100" [appBorderBoxResizeObserver]="'navbarBorderBox'" />
  }
  @if (isBurgerMenuOpen) {
    <app-burger-menu class="d-xl-none" />
  }
}

@if (showSimpleNav$ | async) {
  <app-simple-navbar />
}
